import { graphql } from 'gatsby';
import { useEffect, useRef, useState } from 'react';
import { StyledStatblock, StyledValue, StyledText } from './StatBlock.styles';
import useCountUp from '@/hooks/useCountUp';

const StatBlock = ({
  animate = false,
  elements,
  system,
}: Queries.STAT_BLOCKFragment & { animate?: boolean }) => {
  const { options, value, suffix, text } = elements;
  const hasSuffix = !!suffix?.value;
  const hasDropShadow = !!options?.value?.includes('drop_shadow');
  const isLarge = !!options?.value?.includes('large');

  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const displayValue = useCountUp(Number(value.value), animate && isVisible);

  useEffect(() => {
    if (!animate || !ref.current) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [animate]);

  return (
    <StyledStatblock ref={ref} data-codename={system.codename} hasDropShadow={hasDropShadow}>
      <StyledValue isLarge={isLarge}>
        {displayValue}
        {hasSuffix && <span>{suffix.value}</span>}
      </StyledValue>
      <StyledText>{text.value}</StyledText>
    </StyledStatblock>
  );
};

export default StatBlock;

export const fragment = graphql`
  fragment STAT_BLOCK on kontent_item_stat_block {
    __typename
    system {
      codename
      id
    }
    elements {
      options {
        value
      }
      value {
        value
      }
      suffix {
        value
      }
      text {
        value
      }
    }
  }
`;
